import {
  VERIFICATION_REQUEST_GET,
  VERIFICATION_REQUEST_GET_LIST,
  VERIFICATION_REQUEST_SET_TOKEN,
  VERIFICATION_REQUEST_UPLOAD_DOCUMENT,
  VERIFICATION_REQUEST_REMOVE_DOCUMENT,
  VERIFICATION_REQUEST_COMPLETE_DOCUMENT_UPLOAD,
  VERIFICATION_REQUEST_COMPLETE_QUESTIONNAIRE,
  VERIFICATION_REQUEST_COMPLETE_PAYROLL_LINK,
  VERIFICATION_REQUEST_SKIP_PAYROLL_LINK,
  VERIFICATION_REQUEST_GENERATE_TRUV_BRIDGE_TOKEN,
  VERIFICATION_REQUEST_REQUEST,
  VERIFICATION_REQUEST_SUCCESS,
  VERIFICATION_REQUEST_ERROR,
  VERIFICATION_AUTH_TOKEN_KEY,
  VERIFICATION_REQUEST_START_SESSION_RECORDING,
  VERIFICATION_REQUEST_STOP_SESSION_RECORDING,
  VERIFICATION_REQUEST_SKIP_UPLOAD_DOCUMENTS,
  VERIFICATION_REQUEST_SUBMIT_REFERRAL_INTEREST,
} from '@/store/types'

import axios from '@/store/axios'

import { record } from 'rrweb'

const state = {
  requests: null,
  current: null,
  isLoading: false,
  error: null,
  sessionRecorder: null,
  sessionRecording: [],
}

const getters = {
  getVerificationRequests: (state) => state.requests,
  getCurrentVerificationRequest: (state) => state.current,
  isVerificationRequestLoading: (state) => state.isLoading,
  getVerificationRequestError: (state) => state.error,
}

const actions = {
  [VERIFICATION_REQUEST_GET]: ({ commit }, { id }) => {
    return new Promise((resolve, reject) => {
      commit(VERIFICATION_REQUEST_REQUEST)

      axios
        .get(`/api/v1/verification_requests/${id}`)
        .then((resp) => {
          commit(VERIFICATION_REQUEST_SUCCESS, { current: resp.data })
          resolve(resp)
        })
        .catch((err) => {
          commit(VERIFICATION_REQUEST_ERROR, err)
          reject(err)
        })
    })
  },
  [VERIFICATION_REQUEST_GET_LIST]: ({ commit }) => {
    return new Promise((resolve, reject) => {
      commit(VERIFICATION_REQUEST_REQUEST)

      axios
        .get(`/api/v1/verification_requests/`)
        .then((resp) => {
          commit(VERIFICATION_REQUEST_SUCCESS, { requests: resp.data.results })
          resolve(resp)
        })
        .catch((err) => {
          commit(VERIFICATION_REQUEST_ERROR, err)
          reject(err)
        })
    })
  },
  [VERIFICATION_REQUEST_UPLOAD_DOCUMENT]: ({ commit }, { id, document, fileType, year }) => {
    return new Promise((resolve, reject) => {
      commit(VERIFICATION_REQUEST_REQUEST)

      const formData = new FormData()
      formData.append('document', document)
      formData.append('file_type', fileType)
      if (year != null && !Number.isNaN(year)) {
        formData.append('year', year)
      }

      axios
        .post(`/api/v1/verification_requests/${id}/upload/`, formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        })
        .then((resp) => {
          commit(VERIFICATION_REQUEST_SUCCESS, { current: resp.data })
          resolve(resp)
        })
        .catch((err) => {
          commit(VERIFICATION_REQUEST_ERROR, err)
          reject(err)
        })
    })
  },
  [VERIFICATION_REQUEST_REMOVE_DOCUMENT]: ({ commit }, { id, documentId }) => {
    return new Promise((resolve, reject) => {
      commit(VERIFICATION_REQUEST_REQUEST)

      axios
        .post(`/api/v1/verification_requests/${id}/remove/`, { document_id: documentId })
        .then((resp) => {
          commit(VERIFICATION_REQUEST_SUCCESS, { current: resp.data })
          resolve(resp)
        })
        .catch((err) => {
          commit(VERIFICATION_REQUEST_ERROR, err)
          reject(err)
        })
    })
  },
  [VERIFICATION_REQUEST_SKIP_PAYROLL_LINK]: ({ commit }, { id, skipReason }) => {
    return new Promise((resolve, reject) => {
      commit(VERIFICATION_REQUEST_REQUEST)

      axios
        .post(`/api/v1/verification_requests/${id}/skip_connecting_payroll/`, {
          skip_reason: skipReason,
        })
        .then((resp) => {
          commit(VERIFICATION_REQUEST_SUCCESS)
          resolve(resp)
        })
        .catch((err) => {
          commit(VERIFICATION_REQUEST_ERROR, err)
          reject(err)
        })
    })
  },
  [VERIFICATION_REQUEST_COMPLETE_PAYROLL_LINK]: ({ commit }, { id, publicToken }) => {
    return new Promise((resolve, reject) => {
      commit(VERIFICATION_REQUEST_REQUEST)

      axios
        .post(`/api/v1/verification_requests/${id}/complete/`, {
          public_token: publicToken,
        })
        .then((resp) => {
          commit(VERIFICATION_REQUEST_SUCCESS)
          resolve(resp)
        })
        .catch((err) => {
          commit(VERIFICATION_REQUEST_ERROR, err)
          reject(err)
        })
    })
  },
  [VERIFICATION_REQUEST_COMPLETE_DOCUMENT_UPLOAD]: ({ commit, state }, { id }) => {
    return new Promise((resolve, reject) => {
      commit(VERIFICATION_REQUEST_REQUEST)

      axios
        .post(`/api/v1/verification_requests/${id}/complete/`, {
          session_recording: state.sessionRecording,
        })
        .then((resp) => {
          commit(VERIFICATION_REQUEST_SUCCESS, { current: resp.data, sessionRecording: [] })
          resolve(resp)
        })
        .catch((err) => {
          commit(VERIFICATION_REQUEST_ERROR, err)
          reject(err)
        })
    })
  },
  [VERIFICATION_REQUEST_COMPLETE_QUESTIONNAIRE]: ({ commit, state }, { id, questions }) => {
    return new Promise((resolve, reject) => {
      commit(VERIFICATION_REQUEST_REQUEST)

      axios
        .post(`/api/v1/verification_requests/${id}/complete/`, {
          questions,
          session_recording: state.sessionRecording,
        })
        .then((resp) => {
          commit(VERIFICATION_REQUEST_SUCCESS, { current: resp.data, sessionRecording: [] })
          resolve(resp)
        })
        .catch((err) => {
          commit(VERIFICATION_REQUEST_ERROR, err)
          reject(err)
        })
    })
  },
  [VERIFICATION_REQUEST_SET_TOKEN]: (_, token) => {
    return new Promise((resolve) => {
      localStorage.setItem(VERIFICATION_AUTH_TOKEN_KEY, token)
      resolve()
    })
  },
  [VERIFICATION_REQUEST_GENERATE_TRUV_BRIDGE_TOKEN]: ({ commit }, { id }) => {
    return new Promise((resolve, reject) => {
      commit(VERIFICATION_REQUEST_REQUEST)

      axios
        .post(`/api/v1/verification_requests/${id}/generate_truv_bridge_token/`)
        .then((resp) => {
          commit(VERIFICATION_REQUEST_SUCCESS)
          resolve(resp)
        })
        .catch((err) => {
          commit(VERIFICATION_REQUEST_ERROR, err)
          reject(err)
        })
    })
  },
  [VERIFICATION_REQUEST_START_SESSION_RECORDING]: ({ commit, state }) => {
    return new Promise((resolve) => {
      // If recorder already exists, ignore
      if (state.sessionRecorder) {
        resolve()
        return
      }

      const sessionRecorder = record({
        emit(event) {
          console.log(event)
          state.sessionRecording.push(event)
        },
        // Optional: Only record DOM changes for specific elements
        // blockClass: 'rr-block',
        // Optional: Mask sensitive input text
        // maskTextClass: 'rr-mask',
      })
      commit(VERIFICATION_REQUEST_SUCCESS, { sessionRecorder })
      resolve()
    })
  },
  [VERIFICATION_REQUEST_STOP_SESSION_RECORDING]: ({ commit, state }) => {
    return new Promise((resolve) => {
      if (!state.sessionRecorder) {
        resolve()
        return
      }

      state.sessionRecorder() // Stops recording

      commit(VERIFICATION_REQUEST_SUCCESS, { sessionRecorder: null })
      resolve()
    })
  },
  [VERIFICATION_REQUEST_SKIP_UPLOAD_DOCUMENTS]: ({ commit }, { id, skipYear, skipReason }) => {
    return new Promise((resolve, reject) => {
      commit(VERIFICATION_REQUEST_REQUEST)

      axios
        .post(`/api/v1/verification_requests/${id}/skip_upload_documents_by_year/`, {
          skip_year: skipYear,
          skip_reason: skipReason,
        })
        .then((resp) => {
          commit(VERIFICATION_REQUEST_SUCCESS)
          resolve(resp)
        })
        .catch((err) => {
          commit(VERIFICATION_REQUEST_ERROR, err)
          reject(err)
        })
    })
  },
  [VERIFICATION_REQUEST_SUBMIT_REFERRAL_INTEREST]: ({ commit }, { id, name, email, services }) => {
    return new Promise((resolve, reject) => {
      commit(VERIFICATION_REQUEST_REQUEST)

      axios
        .post(`/api/v1/verification_requests/${id}/submit_referral_interest/`, {
          name,
          email,
          services,
        })
        .then((resp) => {
          commit(VERIFICATION_REQUEST_SUCCESS)
          resolve(resp)
        })
        .catch((err) => {
          commit(VERIFICATION_REQUEST_ERROR, err)
          reject(err)
        })
    })
  },
}

const mutations = {
  [VERIFICATION_REQUEST_REQUEST]: (state) => {
    state.isLoading = true
  },
  [VERIFICATION_REQUEST_SUCCESS]: (
    state,
    { requests, current, sessionRecorder, sessionRecording } = {},
  ) => {
    state.isLoading = false

    if (requests) {
      state.requests = requests
    }

    if (current) {
      state.current = current
    }

    if (sessionRecorder !== undefined) {
      state.sessionRecorder = sessionRecorder
    }

    if (sessionRecording !== undefined) {
      state.sessionRecording = sessionRecording
    }
  },
  [VERIFICATION_REQUEST_ERROR]: (state, err) => {
    state.isLoading = false
    state.error = err
  },
}

export default {
  state,
  getters,
  actions,
  mutations,
}
